<div class="modal-header justify-content-center">
    <h4 class="modal-title">{{'NOTIFICATION_TEXT' | translate}}</h4>
</div>
<div class="modal-body text-center">{{ 'LOGIN_ATTEMPTS_EXCEEDED' | translate }}</div>

<div class="modal-footer d-flex justify-content-center">
    <button class="btn btn-primary cta-blue info-btn" (click)="cancelAccountRemoval()">{{ 'RESET_PASSWORD' | translate }}</button>
</div>